<template>
  <div>
    <a-card
      :style="{ marginBottom: '1em' }"
      :header="$t('common.search')"
      :editable="false"
    >
      <template
        #header-buttons
      >
        <div class="is-pulled-right is-flex buttons">
          <a-select
            :manual-doc="userDoc"
            field="routes.operators.orderBy"
            :label="$t('common.order')"
            :options="keys($store.getters['operators/orderOptions'])"
            :labels="$store.getters['operators/orderOptions']"
          />
        </div>
      </template>

      <a-input
        :style="{ marginTop: '1em' }"
        :manual-doc="userDoc"
        field="routes.operators.search"
        :label="$t('common.quick_search')"
      />
    </a-card>
    <a-table
      :columns="user.routes.operators.columns"
      :data="$store.getters['operators/displayedItems']"
    />
    <more-docs-button
      module="operators"
    />
    <add-doc-button
      :doc-props="{}"
    />
  </div>
</template>

<script>
import ATable from '@/components/ATable'
import MoreDocsButton from '@/components/MoreDocsButton'
import { mapGetters, mapActions } from 'vuex'
import { keys } from 'lodash'

export default {
  components: {
    MoreDocsButton
  },
  data() {
    return {
      userDoc: { module: 'user' }
    }
  },
  created () {
    this.$store.dispatch('operators/fetchDocs')
  },
  methods: {
    keys
  }
}
</script>
